import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../../../../constants'

export const Header = styled.div`
    display: flex;
    font-size: 15px;
    height: 50px;
    justify-content: space-between;
`

export const HeaderLabel = styled.div`
    &:hover {
        cursor: pointer;
        font-weight: bold;
        margin-top: 2px;
        margin-bottom: -2px;
    }
`

export const HeaderIcon = styled(FontAwesomeIcon)`
    color: ${colors.grey};
    margin-left: 5px;

    div:hover > & {
        color: ${colors.white};
        cursor: pointer;
    }
`

export const Brand = styled.div`
    color: ${colors.grey};
`

export const Body = styled.ul`
  align-items: flex-end;
  height: calc( 100% - 60px );
  margin: 0;
  padding: 0;
  width 100%;
`

export const Store = styled.li`
    display: block;
    margin-bottom: 30px;

    &:last-children {
        margin-bottom: 0;
    }
`

export const Details = styled.div`
    align-items: center;
    display: flex;
    height: 50%;
    justify-content: space-between;
    width: 100%;
`

export const Name = styled.div`
    font-weight: bold;
    letter-spacing: 0.5px;
`

export const Interactions = styled.div`
    color: ${colors.grey};
    font-size: 14px;
`

export const StoreCode = styled.span`
    font-weight: normal;
`
